module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message-page-view"
  }, [_c('div', {
    staticClass: "search-view"
  }, [_c('div', {
    staticClass: "search-item-view"
  }, [_c('div', {
    staticClass: "search-title"
  }, [_vm._v("\n        搜索消息:\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "search-item"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 4
      },
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.searchData.searchText),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "searchText", $$v)
      },
      expression: "searchData.searchText"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "search-button"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-search",
      "size": "medium"
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_vm._v("\n          搜索\n        ")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "sketch-view"
  }, [(_vm.loginStatus) ? _c('div', {
    staticClass: "sketch-item-view"
  }, [_c('div', {
    staticClass: "sketch-item"
  }, [_vm._v("\n        当前登录用户:" + _vm._s(_vm.platformUserData.userName) + "\n      ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sketch-item-view"
  }, [_c('div', {
    staticClass: "sketch-item"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.showReg
    }
  }, [_vm._v("\n          用户注册\n        ")])], 1)]), _vm._v(" "), (!_vm.loginStatus) ? _c('div', {
    staticClass: "sketch-item-view"
  }, [_c('div', {
    staticClass: "sketch-item"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.showLogin
    }
  }, [_vm._v("\n          用户登录\n        ")])], 1)]) : _c('div', {
    staticClass: "sketch-item-view"
  }, [_c('div', {
    staticClass: "sketch-item"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.logOut
    }
  }, [_vm._v("\n          退出登录\n        ")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "video-view"
  }, [_vm._l((_vm.dataList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "video-item-view"
    }, [(false) ? _c('el-divider', {
      attrs: {
        "content-position": "center"
      }
    }, [_vm._v("信息")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "message-view"
    }, [_c('el-collapse', [_c('el-collapse-item', {
      attrs: {
        "title": '用户' + item.sourceUserName + '发送的消息'
      }
    }, [_c('div', {
      staticClass: "message-text"
    }, [_vm._v("消息内容: " + _vm._s(item.transmitText))])])], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "publisher-view"
    }, [_vm._v("\n        视频发布人: " + _vm._s(item.videoPublisherName) + "\n      ")]), _vm._v(" "), _c('div', {
      staticClass: "video-head"
    }, [_vm._v("\n        视频标题: " + _vm._s(item.videoText) + "\n      ")]), _vm._v(" "), _c('div', {
      staticClass: "video-item"
    }, [_c('vueMiniPlayer', {
      ref: "vueMiniPlayer",
      refInFor: true,
      attrs: {
        "video": item.videoItem,
        "mutex": true
      },
      on: {
        "fullscreen": _vm.handleFullscreen
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "video-bottom"
    }, [_c('div', {
      staticClass: "bottom-show-view"
    }, [_c('div', {
      staticClass: "bottom-show-item"
    }, [_c('el-tag', {
      attrs: {
        "type": "primary"
      }
    }, [_vm._v("平均评分:" + _vm._s(item.starNum))])], 1), _vm._v(" "), _c('div', {
      staticClass: "bottom-show-item"
    }, [_c('el-tag', {
      attrs: {
        "type": "primary"
      }
    }, [_vm._v("评论数量:" + _vm._s(item.commentNum))])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "bottom-handle-view"
    }, [_c('div', {
      staticClass: "bottom-handle-item"
    }, [_c('el-badge', {
      staticClass: "item",
      attrs: {
        "value": item.tagNum
      }
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      },
      on: {
        "click": function($event) {
          return _vm.videoTag(item)
        }
      }
    }, [_vm._v("点赞")])], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "bottom-handle-item"
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      },
      on: {
        "click": function($event) {
          return _vm.downloadVideo(item)
        }
      }
    }, [_vm._v("下载视频")])], 1), _vm._v(" "), _c('div', {
      staticClass: "bottom-handle-item"
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      },
      on: {
        "click": function($event) {
          return _vm.showCommentView(item)
        }
      }
    }, [_vm._v("评论视频")])], 1), _vm._v(" "), _c('div', {
      staticClass: "bottom-handle-item"
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      },
      on: {
        "click": function($event) {
          return _vm.showCommentDrawer(item)
        }
      }
    }, [_vm._v("查看评论")])], 1), _vm._v(" "), _c('div', {
      staticClass: "bottom-handle-item"
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      },
      on: {
        "click": function($event) {
          return _vm.showVideoTransmit(item)
        }
      }
    }, [_vm._v("转发视频")])], 1), _vm._v(" "), _c('div', {
      staticClass: "bottom-handle-item"
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      },
      on: {
        "click": function($event) {
          return _vm.deleteVideoTransmit(item)
        }
      }
    }, [_vm._v("删除消息")])], 1)])])], 1)
  }), _vm._v(" "), _c('el-drawer', {
    attrs: {
      "title": "视频评论内容",
      "visible": _vm.commentDrawerShow,
      "direction": _vm.commentDrawerDirection,
      "before-close": _vm.handleDrawerClose
    },
    on: {
      "update:visible": function($event) {
        _vm.commentDrawerShow = $event
      }
    }
  }, [_c('div', {
    staticClass: "comment-view"
  }, [_c('el-collapse', {
    on: {
      "change": _vm.handleCommentCollapseChange
    }
  }, _vm._l((_vm.commentList), function(item, index) {
    return _c('el-collapse-item', {
      key: index,
      attrs: {
        "title": '用户' + item.platformUserName + '在' + item.createTime + '的评论'
      }
    }, [_c('div', {
      staticClass: "star-view"
    }, [_vm._v("视频评分: " + _vm._s(item.starNum))]), _vm._v(" "), _c('div', {
      staticClass: "comment-text-view"
    }, [_vm._v(_vm._s(item.commentText))])])
  }), 1)], 1)]), _vm._v(" "), _c('CommentView', {
    ref: "commentView",
    on: {
      "handleSuccess": _vm.commentSuccess
    }
  }), _vm._v(" "), _c('VideoTransmitView', {
    ref: "videoTransmitView",
    on: {
      "handleSuccess": _vm.transmitVideoSuccess
    }
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "pagination-view"
  }, [_c('div', {
    staticClass: "pagination-item-view"
  }, [_c('el-pagination', {
    attrs: {
      "background": true,
      "current-page": _vm.paginationData.currentPage,
      "page-sizes": [5, 10, 60, 80, 100, 200, 300],
      "page-size": _vm.paginationData.itemsPerPage,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.paginationData.totalCount
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)]), _vm._v(" "), _c('RegisterView', {
    ref: "registerView",
    on: {
      "handleSuccess": _vm.regSuccess
    }
  }), _vm._v(" "), _c('LoginView', {
    ref: "loginView",
    on: {
      "handleSuccess": _vm.loginSuccess
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5f20096c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f20096c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/main/TransmitList.vue
// module id = 1292
// module chunks = 1